import React, { useEffect, useState } from 'react';
import Datas from '../data/faq-event/faq-event.json';
import { Container, Row, Col, Button, Collapse } from 'react-bootstrap';
import { Styles } from "./styles/faqEvent.js";
import axios from 'axios';

function FaqEvent() {
    const [open, setOpen] = useState(false);

    const [featuresList, setFeaturesList] = useState([]);

    useEffect(() => {
        const getFeatures = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/community-features/find-all`).then(res => {
                setFeaturesList(res.data)
            }).catch(err => console.error(err))
        }
        getFeatures();
    },[])

    useEffect(() => {
        const accordionButton = document.querySelectorAll(".accordion-button");
        accordionButton.forEach(button => {
            button.addEventListener("click", () => {
                button.classList.toggle("active");
                const content = button.nextElementSibling;

                if (!button.classList.contains("active")) {
                    content.className = "accordion-content show";
                    content.style.maxHeight = content.scrollHeight + "px";
                } else {
                    content.className = "accordion-content";
                    content.style.maxHeight = "0";
                }
            });
        });
    },[featuresList]);

    return (
        <Styles>
            {/* Faq & Event */}
            <section className="event-faq-area">
                
                <Container>
                
                    <Row>
                        <Col className="mb-4">
                        <Button
                            onClick={() => setOpen(!open)}
                            aria-controls="example-collapse-text"
                            aria-expanded={open}
                            className="expand-btn"
                        >
                            {open ? "Collapse All" : "Expand All"}
                        </Button>
                        </Col>
                    </Row>
                    <Row>      
                    {
                        featuresList && featuresList.length > 0 ? featuresList.map((faqData, i) => (                
                            <Col md="6" key={i}>
                                <div className="faq-area">
                                
                                    <div className="faq-box">
                                    
                                        <div className="faq-item" >
                                            <button className="accordion-button active">
                                                <div className="accordion-icon">
                                                <i className="las la-plus"></i></div>
                                                <p>{faqData.featureName}</p>
                                            </button>
                                            <Collapse in={open}>
                                                <div className="accordion-content">
                                                    <p>{faqData.featureDesc}</p>
                                                </div>
                                            </Collapse>
                                        </div>
                                        
                                    </div>
                                </div>
                            </Col>
                        )) : "No feature available"
                    }
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default FaqEvent
